module.exports = __webpack_public_path__ + "img/roomBg.aaa5fe9e.png";